import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  span {
    flex: 1;
  }

  img {
    display: ${({ loaded }) => (loaded ? "block" : "none")};
  }
`;
